import Box from "@mui/material/Box";
import { Stack, Typography, useMediaQuery } from "@mui/material";
import CancelLockupTable from "../components/proposals/cancel-lockup/tables/CancelLockupProposalTable";
import AddButton from "../components/proposals/cancel-lockup/buttons/AddButton";
import theme from "../theme";
import ProposalTabs from "../components/shared/ProposalTabs";
import ProceedTable from "../components/proposals/cancel-lockup/tables/ProceedTable";

export default function CancelLockupPage() {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box>
      <Stack
        direction="row"
        sx={{ width: "100%", marginBottom: 2, alignItems: "center" }}
      >
        <Typography variant={isSmallScreen ? "h6" : "h5"} sx={{ flexGrow: 1 }}>
          Cancel Lockup Proposal
        </Typography>
        <AddButton />
      </Stack>
      <ProposalTabs
        processingTab={<CancelLockupTable />}
        proceedTab={<ProceedTable />}
      />
    </Box>
  );
}
